import {Controller} from '@hotwired/stimulus';
import $ from "jquery";
import * as moment from "moment/moment";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        options: Object,
    };

    connect() {
        const options = {
            cancelClass: 'btn-light',
            applyButtonClasses: 'btn-success',
            singleDatePicker: true,
            locale: {
                firstDay: 1,
                format: 'DD/MM/YYYY',
                applyLabel: translations['date_picker.apply_label'],
                cancelLabel: translations['date_picker.cancel_label'],
                daysOfWeek: [
                    translations['date_picker.days_of_week.sunday'],
                    translations['date_picker.days_of_week.monday'],
                    translations['date_picker.days_of_week.tuesday'],
                    translations['date_picker.days_of_week.wednesday'],
                    translations['date_picker.days_of_week.thursday'],
                    translations['date_picker.days_of_week.friday'],
                    translations['date_picker.days_of_week.saturday'],
                ],
                monthNames: [
                    translations['date_picker.month_names.january'],
                    translations['date_picker.month_names.february'],
                    translations['date_picker.month_names.march'],
                    translations['date_picker.month_names.april'],
                    translations['date_picker.month_names.may'],
                    translations['date_picker.month_names.june'],
                    translations['date_picker.month_names.july'],
                    translations['date_picker.month_names.august'],
                    translations['date_picker.month_names.september'],
                    translations['date_picker.month_names.october'],
                    translations['date_picker.month_names.november'],
                    translations['date_picker.month_names.december'],
                ],
            },
            ...this.optionsValue,
        };

        if (options.singleDatePicker && false === options.autoUpdateInput) {
            $(this.element).on('apply.daterangepicker', (event, picker) => {
                this.element.value = picker.startDate.format(options.locale.format);
                this.element.dispatchEvent(new Event('change'));
                this.element.dispatchEvent(new Event('input'));
            });
        }

        $(this.element).daterangepicker(options);
    }

    disconnect() {
        // TODO: Destroy the instance of daterangepicker
    }
}
